import { useContext } from "react";

import { IPContext, LookupIPContext } from "./LookupIPProvider";

export default function useLookupIP(): IPContext {
  return useContext(LookupIPContext);
}
